import { lazy } from "react";
import { IRoleType } from "@/models/role";

import RouteGuard from "@/components/RouteGuard";
import HealthHubWrapper from "@/components/HealthHubWrapper";
import BlogDetailsPage from "@/views/Patient/BlogDetails";
import DiseaseDetailsPage from "@/views/Patient/DiseaseDetails";
import PlayListPage from "@/views/Patient/PlaylistPage";
import OurAppFeaturePage from "@/components/Footer/OurAppFeature";

const FindDoctor = lazy(() => import("@/views/Doctor/FindDoctor"));
const DoctorProfile = lazy(() => import("@/views/Common/DoctorProfile"));
const Home = lazy(() => import("@/views/Patient/Home"));
const Faq = lazy(() => import("@/views/Patient/FAQ"));
const HealthAssessment = lazy(() => import("@/views/Patient/HealthAssessment"));
const BlogListPage = lazy(() => import("@/views/Patient/BlogListPage"));
const Orders = lazy(() => import("@/views/Patient/Home/Orders"));
const HealthHub = lazy(() => import("@/views/Patient/HealthHub"));
const VideoDetails = lazy(() => import("@/views/Patient/VideoDetails"));
const Medicines = lazy(() => import("@/views/Patient/Medicines"));
const Tests = lazy(() => import("@/views/Patient/Tests"));
const Chat = lazy(() => import("@/views/Patient/Chat"));
const PatientMedicalRecords = lazy(
  () => import("@/components/PatientMedicalRecords")
);
const ContactUs = lazy(() => import("@/components/Footer/ContactUs"));
const AboutUs = lazy(() => import("@/components/Footer/AboutUs"));
const PartnerWithUs = lazy(() => import("@/components/Footer/PartnerWithUs"));
const PaymentSuccessOrFailure = lazy(
  () => import("@/views/Patient/PaymentSuccessOrFailure")
);

const allowedRoles = [IRoleType.PATIENT, IRoleType.GUEST];

const withGuard = (component: React.ReactNode) => (
  <RouteGuard allowedRoles={allowedRoles}>{component}</RouteGuard>
);

const withHealthHubGuard = (component: React.ReactNode) =>
  withGuard(<HealthHubWrapper>{component}</HealthHubWrapper>);

const PatientRoutes = [
  { path: "/", component: withGuard(<Home />) },
  { path: "/home", component: withGuard(<Home />) },
  { path: "/find-doctor", component: withGuard(<FindDoctor />) },
  { path: "/medicines", component: withGuard(<Medicines />) },
  { path: "/test-reports", component: withGuard(<Tests />) },
  { path: "/doctor-profile", component: withGuard(<DoctorProfile />) },
  { path: "/medical-records", component: withGuard(<PatientMedicalRecords />) },
  { path: "/faq", component: withGuard(<Faq />) },
  { path: "/health-assessment", component: withGuard(<HealthAssessment />) },
  { path: "/order-list", component: withGuard(<Orders />) },
  { path: "/chat", component: withGuard(<Chat />) },
  { path: "/about-us", component: withGuard(<AboutUs />) },
  { path: "/contact-us", component: withGuard(<ContactUs />) },
  { path: "/app-feature", component: withGuard(<OurAppFeaturePage />) },
  { path: "/partner-with-us", component: withGuard(<PartnerWithUs />) },

  // HealthHub routes with extra wrapper
  { path: "/health-hub", component: withHealthHubGuard(<HealthHub />) },
  {
    path: "/health-hub/video",
    component: withHealthHubGuard(<VideoDetails />),
  },
  {
    path: "/health-hub/blog-list",
    component: withHealthHubGuard(<BlogListPage />),
  },
  {
    path: "/health-hub/playlist",
    component: withHealthHubGuard(<PlayListPage />),
  },
  {
    path: "/health-hub/blog",
    component: withHealthHubGuard(<BlogDetailsPage />),
  },
  {
    path: "/health-hub/disease",
    component: withHealthHubGuard(<DiseaseDetailsPage />),
  },
  {
    path: "/appointment/success",
    component: withGuard(<PaymentSuccessOrFailure />),
  },
  {
    path: "/appointment/failure",
    component: withGuard(<PaymentSuccessOrFailure />),
  },
];

export default PatientRoutes;
